import { environment } from '@ib-env/environment';
import { getPhoneConfig } from 'credebt-shared';

const PHONE_CONFIG = getPhoneConfig(environment.production);

export { PHONE_CONFIG };
